import React from 'react';
import { Accordion } from 'components/accordion';

interface IStatusRow {
    title: string;
    id?:string;
    children: React.ReactNode | React.ReactNodeArray;
}
export const StatusRow: React.SFC<IStatusRow> = (props: IStatusRow) => (
    <Accordion text={props.title} id={props.id}>
        <div className="grid-wrapper">
            {props.children}
        </div>
    </Accordion>
);
